<template>
    <div class="container-bg1">
        <van-nav-bar fixed title="我的关注" />

        <van-sticky :offset-top="46">
            <van-dropdown-menu>
                <van-dropdown-item v-model="lotteryId" :options="lotteryOption" @change="onChange" />
                <van-dropdown-item v-model="days" :options="daysOption" @change="onChange" />
            </van-dropdown-menu>
        </van-sticky>

        <van-pull-refresh class="case-list" v-model="refreshing" style="min-height: 100vh;" success-text="刷新成功" @refresh="onRefresh">

            <!-- <div v-if="customLoading"
                style="margin-top: 50px; display: flex; align-items: center; justify-content: center; width: 100%;">
                <van-loading type="spinner" color="#1989fa" />
            </div> -->

            <van-list v-model="loading" :finished="finished" finished-text="没有更多了"
                :immediate-check="false" @load="onLoad">
                <!-- 循环渲染列表项，记得加上 :key -->
                <div v-for="item in list" :key="item.id" class="case-item"
                    @click="toMavinPage(item.id)">
                    <!-- 整行 -->
                    <van-row class="item-row">
                        <!-- 头像列 -->
                        <van-col span="4" class="col-center algin-center">
                            <van-image class="head-img" round fit="cover" width="40" height="40"
                                :src="item.headImg | imgFilter" />
                        </van-col>
                        <!-- 内容列 -->
                        <van-col span="18" class="content">
                            <!-- 内容列第1行 -->
                            <van-row type="flex" justify="space-between" class="item-row1">
                                <van-col span="24" class="col-center font1">
                                    {{ item.nickName }}
                                </van-col>
                            </van-row>
                            <!-- 内容列第2行 -->
                            <van-row type="flex" justify="space-between" class="item-row2">
                                <van-col span="24" class="col-center font3 lh color-red">
                                    {{ item.playtypeName }} 近{{ days }}期中{{ item.sumWinCount }}期
                                </van-col>
                            </van-row>
                        </van-col>
                        <van-col span="2" class="col-center algin-right" style="color: #ccc;">
                            <van-icon name="arrow" />
                        </van-col>
                    </van-row>
                </div>
            </van-list>

        </van-pull-refresh>
    </div>
</template>

<script>
import { user } from '@/api'

export default {
    name: 'Follow',
    data() {
        return {
            customLoading: true, // 这个暂时没有用了，本意是想自己控制一个加载效果，最后都统一到组件自身的加载效果上去了
            isloading: false,// 自定义标识正在等待接口响应数据，其他提交都要阻止，防止重复提交接口
            refreshing: false,// 下拉刷新状态的控制
            loading: false,// 上拉加载状态的控制
            finished: false,// 标识是否还有数据，当前是否是最后一页
            list: [],
            pageNum: 1,
            pageSize: 10,
            lotteryId: 1,
            days: 10,
            lotteryOption: [
                { text: '福彩3D', value: 1 },
                { text: '排列三', value: 2 },
            ],
            daysOption: [
                { text: '近10期', value: 10 },
                { text: '近20期', value: 20 },
                { text: '近30期', value: 30 },
                { text: '近50期', value: 50 },
                { text: '近100期', value: 100 },
            ],
        }
    },
    filters: {
        imgFilter(v) {
            return '/img/headImg/' + v
        },
    },
    created() {
        this.onLoad()
    },
    methods: {
        // 查看专家
        toMavinPage(id){
            this.$router.push({
                path: '/mavin',
                query: { id }
            })
        },

        // 切换条件
        async onChange() {
            // 1. 重置分页参数
            this.pageNum = 1
            this.finished = false
            this.list = []

            // 2. ✅ 滚动到顶部
            window.scrollTo({ top: 0, behavior: 'smooth' })
            // 或者立即滚动（无动画）
            // window.scrollTo(0, 0)
            // ✅ 滚动到顶部（兼容写法）
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0  // 兼容 Safari

            await this.onLoad()
        },

        // 下拉刷新
        async onRefresh() {
            try {
                if (this.isloading) {
                    console.log('等待服务器响应，请稍后操作...')
                    this.refreshing = false
                    return
                }
                this.isloading = true

                // 1. 重置分页参数
                this.pageNum = 1
                this.finished = false

                // 2. 请求第一页数据
                const data = await user.getFollow({
                    lotteryId: this.lotteryId,
                    days: this.days,
                    pageNum: 1,
                    pageSize: this.pageSize,
                })

                const list = data.pageInfo.list || []

                // 3. 替换列表（不是追加）
                this.list = list

                // 4. 判断是否只有一页
                if (list.length < this.pageSize) {
                    this.finished = true
                }

                // 5. 页码 +1（为后续上拉加载准备）
                this.pageNum = 2

                // 6. 提示刷新成功
                this.$toast.success('刷新成功')
            } catch (error) {
                console.error('刷新失败:', error)
                this.$toast.fail('刷新失败')
            } finally {
                // ✅ 必须结束下拉刷新状态
                this.refreshing = false
                this.isloading = false
            }
        },

        // 获取数据
        async onLoad() {
            console.log('onLoad被触发')
            try {
                if (this.isloading) {
                    console.log('等待服务器响应，请稍后操作...')
                    return
                }
                this.isloading = true

                // 🤔注意看这句话起作用不，不起作用就删了吧：为了防止上拉刷新被vant组件反复触发，这里强行设置
                // 这句话有另一个作用是将加载状态显示出来，这个应该是上拉刷新的加载状态
                this.loading = true

                // 如果正在加载或已加载完成，不执行
                if (this.finished) return

                const data = await user.getFollow({
                    lotteryId: this.lotteryId,
                    days: this.days,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                })
                console.log('异步加载数据结束')
                const list = data.pageInfo.list || [];
                // // 1. 将新数据追加到列表末尾
                // this.list.push(...list)

                // 为了防止插入重复数据，这里手动遍历处理
                list.forEach(ele => {
                    if(!this.list.some(i=>i.id==ele.id)){
                        this.list.push(ele)
                    }
                });

                // 统一放到finally里处理
                // // 2. 加载状态结束，允许下一次触发 load 事件
                // this.loading = false;

                // 3. 如果数据全部加载完成，则禁用上拉加载
                if (list.length < this.pageSize) {
                    this.finished = true;
                }
                // 4. 页码加1，为加载下一页做准备
                this.pageNum += 1;
            } catch (error) {
                console.log('获取用户帖子错误：' + error)
            } finally {
                this.loading = false
                this.isloading = false
            }
        },
    }
}
</script>

<style scoped>
.case-list {
    padding: 50px 16px;
}

.case-item {
    padding: 10px;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 8px;
}

.item-row {
    height: 50px;
}

.item-row1 {
    height: 26px;
    width: 100%;
}

.item-row2 {
    height: 24px;
    width: 100%;
}

.van-tag {
    padding: 3px 5px;
}

.content {
    padding-top: 0px;
}

.head-img {
    width: 100%;
}

.lh {
    line-height: 16px;
}

.item-content {
    padding: 5px 0;
}

::v-deep .van-dropdown-menu__bar {
    background: linear-gradient(to bottom, #FEECEB -44px,
            #F3F3F3 100vh);
    box-shadow: none;
}
</style>